/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

const StyledSVG = styled.svg`
  .cls-1 {
    fill: ${(props) => props.theme.palette.highlight.main};
  }
  .cls-2 {
    fill: ${(props) => props.theme.palette.common.white};
  }
`;
export const SVG = ({ className }: { className?: string }) => (
  <StyledSVG className={className} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 744.5977 427.9756'>
    <g id='Ebene_2' data-name='Ebene 2'>
      <g id='Ebene_1-2' data-name='Ebene 1'>
        <path
          d='M247.4937,190a32.9527,32.9527,0,0,0,5.968-.5325'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M264.7661,184.9646C310.0491,155.9122,301.6035,11,338.4937,11c40.967,0,34.5825,144.1539,71.5739,168.5216'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
          strokeDasharray='12.2437 12.2437'
        />
        <path
          d='M415.5816,182.1366a20.2423,20.2423,0,0,0,5.9121.8634'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <line
          x1='216.4937'
          y1='4'
          x2='216.4937'
          y2='190'
          fill='#fff'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <line
          x1='430.4937'
          y1='190'
          x2='216.4937'
          y2='190'
          fill='#fff'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M240.4937,190c82,0,84-75,170-73'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M503.4937,103V99.1c0-6.3354,5.4535-11.5189,12-11.5189A11.6463,11.6463,0,0,1,527.0792,99.1c.3927,14.5092,2.37,40.7679-.5215,55.0557a327.3373,327.3373,0,0,0-13.5606,76.7931H441.7906a2.5891,2.5891,0,0,1-2.5738-2.298,53.3177,53.3177,0,0,1-.2814-5.9957c0-19.659-12.8652-42.6969-12.8652-42.6969l-.2262-.4431-16.8114-36.4177c-2.2223-5.609-.3866-36.3116,14.7689-49.3254'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M424.2886,135.0062l.1738-52.9872c0-6.3355,5.8676-11.519,13.039-11.519h0c7.1714,0,13.039,5.1835,13.039,11.519v0'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M477.2708,98.9135V92.1557c0-6.3355,5.8676-11.519,13.0391-11.519h0c7.1714,0,13.1838,5.1835,13.1838,11.519v9.5223'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M477.2708,93V86.0122c0-6.3354-5.8675-11.519-13.039-11.519h0c-7.1715,0-13.7381,5.1836-13.7381,11.519V95'
          fill='none'
          stroke='#009abc'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='8'
        />
        <path
          d='M29.01,342.4092C9.9961,342.4092,0,330.6475,0,308.3027c0-23.62,12.251-33.9111,28.4219-33.9111,5.9785,0,13.623,1.2744,17.3476,3.2344a79.1294,79.1294,0,0,1-1.8623,10.8789,34.88,34.88,0,0,0-14.8974-3.333c-9.5069,0-15.877,5.2929-15.877,23.1308,0,16.8565,5.1943,23.3252,16.1709,23.3252a31.3382,31.3382,0,0,0,15.877-4.5078,60.72,60.72,0,0,1,1.9609,10.9766C42.2412,341.0371,34.8906,342.4092,29.01,342.4092Z'
          fill='#fff'
        />
        <path
          d='M78.8906,342.4092c-13.4267,0-22.64-8.0371-22.64-26.5606,0-16.955,9.6045-26.5595,22.9336-26.5595,12.9375,0,22.64,7.4482,22.64,26.5595C101.8242,333.2939,91.8281,342.4092,78.8906,342.4092Zm.1963-43.5156c-6.5664,0-10.8789,4.0185-10.8789,16.955,0,12.545,3.7246,16.9551,10.78,16.9551,6.959,0,10.8789-4.3115,10.8789-16.9551S86.0449,298.8936,79.0869,298.8936Z'
          fill='#fff'
        />
        <path
          d='M141.8076,301.4414a21.7532,21.7532,0,0,0-4.7051-.49,13.7711,13.7711,0,0,0-10.29,3.9209v36.5566H115.64V290.6611a100.6794,100.6794,0,0,1,11.1729-.6865v6.5664H127.4c5.0957-6.664,8.4287-7.2519,11.6631-7.2519a13.2951,13.2951,0,0,1,3.7236.5879A75.6919,75.6919,0,0,1,141.8076,301.4414Z'
          fill='#fff'
        />
        <path
          d='M173.166,342.4092c-13.4267,0-22.64-8.0371-22.64-26.5606,0-16.955,9.6045-26.5595,22.9336-26.5595,12.9375,0,22.64,7.4482,22.64,26.5595C196.1,333.2939,186.1035,342.4092,173.166,342.4092Zm.1963-43.5156c-6.5664,0-10.8789,4.0185-10.8789,16.955,0,12.545,3.7246,16.9551,10.78,16.9551,6.959,0,10.8789-4.3115,10.8789-16.9551S180.32,298.8936,173.3623,298.8936Z'
          fill='#fff'
        />
        <path
          d='M239.415,341.4287v-35.38c0-4.4111-1.7646-6.8613-7.6445-6.8613a17.9447,17.9447,0,0,0-10.6826,3.332v38.9092H209.915V290.6611a100.6794,100.6794,0,0,1,11.1729-.6865v5.0967h.5879c5.0957-4.7041,9.4082-5.7822,14.1133-5.7822,7.9384,0,14.7988,4.0175,14.7988,15.7793v36.36Z'
          fill='#fff'
        />
        <path
          d='M310.3672,334.8623c0,5.6846-3.5283,7.5469-8.1348,7.5469-4.3125,0-7.5459-1.0781-9.2129-5.293H292.53c-4.4112,3.626-8.7227,5.293-13.917,5.293-8.8213,0-15.0938-4.4112-15.0938-14.4072,0-11.0752,6.6651-14.9952,18.8174-15.4854l9.0166-.3916V301.3438c-2.45-1.4708-6.2724-2.0586-9.9961-2.0586a32.2916,32.2916,0,0,0-11.7607,2.1562,58.6734,58.6734,0,0,1-1.5684-10.1924,50.6093,50.6093,0,0,1,14.1133-1.96c7.1543,0,15.19,1.666,19.8945,5.4882v33.126c0,2.45.6866,3.333,3.0391,3.333h5.292Zm-19.0137-15.1914-9.1142.3916c-5.4883.1973-7.4483,1.8633-7.4483,7.1553,0,4.5078,1.96,6.37,6.37,6.37,3.4307,0,7.6446-1.0781,10.1924-3.0381Z'
          fill='#fff'
        />
        <path
          d='M335.0605,342.4092c-5.4882,0-12.5449-.7842-17.8369-3.0391a60.1271,60.1271,0,0,1,2.45-10.584,45.2219,45.2219,0,0,0,16.8575,3.2334c6.37,0,9.31-2.9394,9.31-8.2324,0-12.25-28.52-10.0937-28.52-30.1855,0-12.545,9.8994-19.21,23.8164-19.21a73.65,73.65,0,0,1,14.4062,1.5684,74.0605,74.0605,0,0,1-1.5673,10.6826,61.0534,61.0534,0,0,0-14.7012-1.8613c-6.86,0-9.4092,3.0371-9.4092,7.9375,0,10.9765,28.5205,9.7031,28.5205,29.99C358.3867,335.45,348.9775,342.4092,335.0605,342.4092Z'
          fill='#fff'
        />
        <path
          d='M377.7881,283.2129c-4.2149,0-6.2725-3.1367-6.2725-6.5664s2.0576-6.7637,6.37-6.7637,6.37,3.2344,6.37,6.7637C384.2559,280.1738,382.1006,283.2129,377.7881,283.2129ZM372.3,341.4287V290.27h11.1729v51.1592Z'
          fill='#fff'
        />
        <path
          d='M455.7,341.4287V305.95c0-4.1162-1.667-6.7627-6.959-6.7627a14.51,14.51,0,0,0-9.4082,3.332v38.9092H428.16v-35.38c0-4.3125-1.6661-6.8613-6.7627-6.8613a16.08,16.08,0,0,0-9.6045,3.332v38.9092H400.62V290.6611a100.6778,100.6778,0,0,1,11.1729-.6865v5.0967h.5879c4.7041-4.2139,8.2324-5.7822,13.23-5.7822,5.0967,0,9.2129,1.7636,11.4668,6.664,5.0967-5.0957,9.5069-6.664,14.9951-6.664,8.3311,0,14.8,4.3125,14.8,15.6816v36.458Z'
          fill='#fff'
        />
        <path
          d='M512.8311,341.4287v-4.41h-.5879c-4.6065,3.8222-9.0166,5.3906-14.0147,5.3906-7.8408,0-14.7988-4.0186-14.7988-15.7793V290.6611a82.3923,82.3923,0,0,1,11.1728-.6865v35.3809c0,4.6064,2.0577,7.1543,8.2325,7.1543a19.7342,19.7342,0,0,0,9.9961-2.6455V290.6611a82.4014,82.4014,0,0,1,11.1728-.6865v51.4541Z'
          fill='#fff'
        />
        <path d='M541.1514,341.4287V269.2949a100.0321,100.0321,0,0,1,11.1728-.7832v72.917Z' fill='#fff' />
        <path
          d='M612.3984,334.8623c0,5.6846-3.5283,7.5469-8.1347,7.5469-4.3125,0-7.5459-1.0781-9.2129-5.293h-.4893c-4.4111,3.626-8.7226,5.293-13.917,5.293-8.8213,0-15.0937-4.4112-15.0937-14.4072,0-11.0752,6.665-14.9952,18.8174-15.4854l9.0166-.3916V301.3438c-2.45-1.4708-6.2725-2.0586-9.9961-2.0586a32.2922,32.2922,0,0,0-11.7608,2.1562A58.6739,58.6739,0,0,1,570.06,291.249a50.6093,50.6093,0,0,1,14.1133-1.96c7.1542,0,15.19,1.666,19.8945,5.4882v33.126c0,2.45.6865,3.333,3.039,3.333h5.292Zm-19.0136-15.1914-9.1143.3916c-5.4883.1973-7.4482,1.8633-7.4482,7.1553,0,4.5078,1.96,6.37,6.37,6.37,3.4306,0,7.6445-1.0781,10.1924-3.0381Z'
          fill='#fff'
        />
        <path
          d='M640.13,342.4092c-11.3682,0-16.3672-5.5869-16.3672-17.544V300.07h-5.9785V290.27h5.9785V279.4883a69.9927,69.9927,0,0,1,11.1728-1.8623V290.27h13.1329a67.7707,67.7707,0,0,1-.6856,9.8008H634.9355v25.5791c0,5.293,1.961,6.37,6.6651,6.37a18.4828,18.4828,0,0,0,7.3506-1.5674,58.98,58.98,0,0,1,1.5674,9.7022A27.9126,27.9126,0,0,1,640.13,342.4092Z'
          fill='#fff'
        />
        <path
          d='M680.7012,342.4092c-13.4268,0-22.64-8.0371-22.64-26.5606,0-16.955,9.6045-26.5595,22.9336-26.5595,12.9375,0,22.64,7.4482,22.64,26.5595C703.6348,333.2939,693.6387,342.4092,680.7012,342.4092Zm.1963-43.5156c-6.5664,0-10.8789,4.0185-10.8789,16.955,0,12.545,3.7246,16.9551,10.78,16.9551,6.959,0,10.8789-4.3115,10.8789-16.9551S687.8555,298.8936,680.8975,298.8936Z'
          fill='#fff'
        />
        <path
          d='M743.6182,301.4414a21.7546,21.7546,0,0,0-4.7051-.49,13.7714,13.7714,0,0,0-10.29,3.9209v36.5566H717.45V290.6611a100.676,100.676,0,0,1,11.1728-.6865v6.5664h.5879c5.0957-6.664,8.4287-7.2519,11.6631-7.2519a13.2958,13.2958,0,0,1,3.7237.5879A75.6919,75.6919,0,0,1,743.6182,301.4414Z'
          fill='#fff'
        />
        <path d='M178.5273,416.4609V382.09h4.2832v34.3711Z' fill='#fff' stroke='#000' strokeMiterlimit='10' />
        <path
          d='M201.4766,416.9707c-5.3037,0-7.293-2.7031-7.293-8.3633v-15.35H190.92v-3.416h3.2637v-5.8135a19.1435,19.1435,0,0,1,3.9268-.6631v6.4766h6.6806a25.7647,25.7647,0,0,1-.2549,3.416H198.11v15.6563c0,3.3652.9687,4.3339,3.621,4.3339a9.7445,9.7445,0,0,0,3.875-.8164,15.78,15.78,0,0,1,.6124,3.57A12.7264,12.7264,0,0,1,201.4766,416.9707Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M215.5518,379.6426a6.983,6.983,0,0,1,1.4277,2.2949,6.8053,6.8053,0,0,0-4.1816,6.6289h1.9375a17.6644,17.6644,0,0,1,.6123,4.8965h-5.5586v-3.8252C209.7891,384.9971,211.7266,381.4785,215.5518,379.6426Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M227.64,416.9707a17.0883,17.0883,0,0,1-7.5986-1.6318,26.2853,26.2853,0,0,1,1.0713-3.5694,16.8159,16.8159,0,0,0,7.3428,1.58c3.3144,0,4.6406-1.376,4.6406-3.8242,0-5.7617-12.5449-4.2324-12.5449-12.2383,0-5.2012,4.2842-7.9551,9.6387-7.9551a24.7485,24.7485,0,0,1,6.1191.7647,16.2175,16.2175,0,0,1-.6123,3.7226,20.51,20.51,0,0,0-6.4766-.97c-3.0088,0-4.5888,1.3262-4.5888,3.9785,0,4.8955,12.5957,3.7227,12.5957,12.4424C237.2266,414.4727,232.79,416.9707,227.64,416.9707Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M257.626,384.8438a2.2882,2.2882,0,0,1-2.3457-2.4981,2.4016,2.4016,0,1,1,4.7939,0A2.2889,2.2889,0,0,1,257.626,384.8438Zm-1.9375,31.6171V389.8418h3.9775v26.6191Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M285.7256,416.4609V397.44c0-2.7022-1.2754-4.4874-4.6914-4.4874a11.7107,11.7107,0,0,0-7.14,2.295v21.2138H269.917v-26.416a24.7859,24.7859,0,0,1,3.9775-.3047v2.6h.2041a11.5585,11.5585,0,0,1,8.0577-3.0078c4.0283,0,7.496,1.8868,7.496,8.0059v19.123Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M320.5078,416.002c-2.8047,8.0566-5.9668,11.4736-10.6582,11.4736a9.8656,9.8656,0,0,1-4.5381-.9688,14.8848,14.8848,0,0,1,.8662-3.6709,9.4672,9.4672,0,0,0,3.9268.8155c2.0908,0,3.5185-1.1221,4.59-3.62l1.5293-3.57a226.2021,226.2021,0,0,1-9.1787-26.416,24.4466,24.4466,0,0,1,3.876-.3564l6.374,19.582a20.4962,20.4962,0,0,1,.8155,3.1611h.2041a22.9482,22.9482,0,0,1,.8671-3.2119l6.4258-19.5312a20.38,20.38,0,0,1,3.875.3564Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M345.293,416.9707c-6.68,0-11.1162-4.0283-11.1162-13.8193,0-8.8731,4.6914-13.8194,11.372-13.8194,6.73,0,11.167,4.0284,11.167,13.8194C356.7158,412.5342,351.77,416.9707,345.293,416.9707Zm.2041-24.1719c-4.0283,0-7.0371,2.1934-7.0371,10.3526,0,7.9043,2.55,10.3525,6.9355,10.3525,4.0283,0,7.0371-2.1934,7.0371-10.3525C352.4326,395.2471,349.8828,392.7988,345.4971,392.7988Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M380.4824,416.4609V414.166h-.2041a12.981,12.981,0,0,1-8.0058,2.8047c-3.9776,0-7.3946-1.8867-7.3946-8.0059V389.9941a32.3955,32.3955,0,0,1,3.9268-.3056v19.123c0,2.7539,1.2236,4.5381,4.6914,4.5381a12.6886,12.6886,0,0,0,6.9863-2.09V389.9941a32.4486,32.4486,0,0,1,3.9776-.3056v26.7724Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M407.1553,393.7168a9.244,9.244,0,0,0-2.2949-.2539c-1.835,0-3.6709.3047-6.1192,2.9062v20.0918h-3.9775v-26.416a24.7859,24.7859,0,0,1,3.9775-.3047v3.3653h.2041c3.0088-3.4678,4.8447-3.7735,6.5274-3.7735a7.5994,7.5994,0,0,1,2.0908.2539A28.3025,28.3025,0,0,1,407.1553,393.7168Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M440.3555,416.4609V397.44c0-2.754-1.3262-4.4874-4.6914-4.4874a12.036,12.036,0,0,0-7.14,2.295v21.2138h-3.9775v-37.583a24.5231,24.5231,0,0,1,3.9775-.3574V392.34h.2041a11.6252,11.6252,0,0,1,8.0576-3.0078c4.1817,0,7.4961,2.0391,7.4961,8.0059v19.123Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M475.0859,414.166c0,1.9883-1.122,2.8047-3.11,2.8047-2.04,0-3.8252-.6621-4.6914-2.7539H467.08a11.27,11.27,0,0,1-7.5479,2.7539c-4.5381,0-7.7-2.2949-7.7-7.1894,0-5.5586,3.2129-7.752,9.4854-8.0069l5.6094-.2549V394.125a13.1584,13.1584,0,0,0-5.711-1.2236,17.24,17.24,0,0,0-6.2724,1.122,13.8511,13.8511,0,0,1-.51-3.6718,22.9052,22.9052,0,0,1,6.8838-1.02c3.417,0,7.2412.7647,9.4346,2.4981v19.48c0,1.2237.3564,1.6827,1.5293,1.6827h2.8046Zm-8.1591-9.6377-5.7627.2549c-3.9258.1523-5.15,1.4277-5.15,4.7422,0,2.9062,1.2246,4.08,4.2324,4.08a12.1408,12.1408,0,0,0,6.6807-2.1934Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M497.22,416.4609V397.44c0-2.7022-1.2754-4.4874-4.6914-4.4874a11.71,11.71,0,0,0-7.14,2.295v21.2138h-3.9776v-26.416a24.7871,24.7871,0,0,1,3.9776-.3047v2.6h.2041a11.5584,11.5584,0,0,1,8.0576-3.0078c4.0283,0,7.4961,1.8868,7.4961,8.0059v19.123Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M526.2393,416.4609v-2.2441h-.2041a10.4374,10.4374,0,0,1-7.4454,2.7539c-5.5585,0-9.332-3.7734-9.332-13.0039,0-10.5039,4.5889-14.6348,11.7285-14.6348a15.4427,15.4427,0,0,1,5.253.9688V378.8779a25.0548,25.0548,0,0,1,3.9775-.3574v37.94Zm0-22.4375a12.08,12.08,0,0,0-5.2022-1.122c-4.7422,0-7.4961,2.2949-7.4961,10.5556,0,7.8535,2.1416,9.9444,6.2217,9.9444a11.2507,11.2507,0,0,0,6.4766-2.04Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M545.7734,416.9707a17.0883,17.0883,0,0,1-7.5986-1.6318,26.2853,26.2853,0,0,1,1.0713-3.5694,16.8156,16.8156,0,0,0,7.3428,1.58c3.3144,0,4.6406-1.376,4.6406-3.8242,0-5.7617-12.5449-4.2324-12.5449-12.2383,0-5.2012,4.2842-7.9551,9.6386-7.9551a24.7486,24.7486,0,0,1,6.1192.7647,16.1689,16.1689,0,0,1-.6123,3.7226,20.5108,20.5108,0,0,0-6.4766-.97c-3.0078,0-4.5889,1.3262-4.5889,3.9785,0,4.8955,12.5958,3.7227,12.5958,12.4424C555.36,414.4727,550.9238,416.9707,545.7734,416.9707Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
        <path
          d='M563.7246,417.0215a2.2093,2.2093,0,0,1-2.3457-2.3965,2.3463,2.3463,0,0,1,2.3975-2.55,2.298,2.298,0,0,1,2.2939,2.55A2.1838,2.1838,0,0,1,563.7246,417.0215Z'
          fill='#fff'
          stroke='#000'
          strokeMiterlimit='10'
        />
      </g>
    </g>
  </StyledSVG>
);
export default SVG;
